import { jsxs as g, jsx as i } from "react/jsx-runtime";
import * as n from "react";
import { useState as G, useId as L, useEffect as M } from "react";
import { q as j } from "../index-DiWzAyMV.js";
import { u as q } from "../index-DoOsnuB6.js";
import { P as S, c as z } from "../index-D8UDu4KA.js";
import { a as A, c as I } from "../index-eoE_jzLb.js";
import { u as K } from "../index-BZPx6jYI.js";
import { u as T } from "../index-4vbonZJj.js";
import { P as X } from "../index-CRtCLpV2.js";
import { c as w } from "../clsx-OuTLNxxd.js";
import { L as F } from "../Label-C6Cio33A.js";
import '../Checkbox.css';var E = "Checkbox", [$] = z(E), [J, Q] = $(E), N = n.forwardRef(
  (e, a) => {
    const {
      __scopeCheckbox: t,
      name: o,
      checked: h,
      defaultChecked: c,
      required: d,
      disabled: s,
      value: f = "on",
      onCheckedChange: b,
      form: k,
      ...v
    } = e, [l, C] = n.useState(null), y = q(a, (r) => C(r)), _ = n.useRef(!1), R = l ? k || !!l.closest("form") : !0, [p = !1, P] = A({
      prop: h,
      defaultProp: c,
      onChange: b
    }), D = n.useRef(p);
    return n.useEffect(() => {
      const r = l == null ? void 0 : l.form;
      if (r) {
        const x = () => P(D.current);
        return r.addEventListener("reset", x), () => r.removeEventListener("reset", x);
      }
    }, [l, P]), /* @__PURE__ */ g(J, { scope: t, state: p, disabled: s, children: [
      /* @__PURE__ */ i(
        S.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(p) ? "mixed" : p,
          "aria-required": d,
          "data-state": H(p),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: f,
          ...v,
          ref: y,
          onKeyDown: I(e.onKeyDown, (r) => {
            r.key === "Enter" && r.preventDefault();
          }),
          onClick: I(e.onClick, (r) => {
            P((x) => u(x) ? !0 : !x), R && (_.current = r.isPropagationStopped(), _.current || r.stopPropagation());
          })
        }
      ),
      R && /* @__PURE__ */ i(
        U,
        {
          control: l,
          bubbles: !_.current,
          name: o,
          value: f,
          checked: p,
          required: d,
          disabled: s,
          form: k,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(c) ? !1 : c
        }
      )
    ] });
  }
);
N.displayName = E;
var O = "CheckboxIndicator", B = n.forwardRef(
  (e, a) => {
    const { __scopeCheckbox: t, forceMount: o, ...h } = e, c = Q(O, t);
    return /* @__PURE__ */ i(X, { present: o || u(c.state) || c.state === !0, children: /* @__PURE__ */ i(
      S.span,
      {
        "data-state": H(c.state),
        "data-disabled": c.disabled ? "" : void 0,
        ...h,
        ref: a,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
B.displayName = O;
var U = (e) => {
  const { control: a, checked: t, bubbles: o = !0, defaultChecked: h, ...c } = e, d = n.useRef(null), s = K(t), f = T(a);
  n.useEffect(() => {
    const k = d.current, v = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (s !== t && C) {
      const y = new Event("click", { bubbles: o });
      k.indeterminate = u(t), C.call(k, u(t) ? !1 : t), k.dispatchEvent(y);
    }
  }, [s, t, o]);
  const b = n.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ i(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: h ?? b.current,
      ...c,
      tabIndex: -1,
      ref: d,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function H(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var V = N, W = B;
const Y = "_checkbox_1hk8s_32", Z = "_shouldHighlightOnChecked_1hk8s_32", ee = "_checked_1hk8s_32", te = "_checkboxBox_1hk8s_53", oe = "_indicator_1hk8s_64", ce = "_checkboxGroup_1hk8s_83", m = {
  checkbox: Y,
  shouldHighlightOnChecked: Z,
  checked: ee,
  checkboxBox: te,
  indicator: oe,
  checkboxGroup: ce
}, ke = ({ children: e, className: a, label: t, ...o }) => (!t && !o["aria-label"] && !o["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), // `...props` last: the type accepts every fieldset attribute, and only three were forwarded, so
// `disabled` (which should disable every control in the group), `name` and `id` were dropped. The
// two aria props are computed above from `label`, so they are spread first and then overridden
// deliberately when the caller set them and there is no visible label.
/* @__PURE__ */ g(
  "fieldset",
  {
    className: w(m.checkboxGroup, a),
    ...o,
    "aria-label": t ? void 0 : o["aria-label"],
    "aria-labelledby": t ? void 0 : o["aria-labelledby"],
    children: [
      t && /* @__PURE__ */ i("legend", { children: t }),
      e
    ]
  }
)), pe = ({
  checked: e,
  children: a,
  className: t,
  onCheckedChange: o,
  shouldHighlightOnChecked: h = !0,
  ...c
}) => {
  const [d, s] = G(e), f = L();
  return M(() => {
    s(e);
  }, [e]), /* @__PURE__ */ g(
    F,
    {
      className: w(
        m.checkbox,
        {
          [m.checked]: d,
          [m.shouldHighlightOnChecked]: h
        },
        t
      ),
      "data-cxy-name": "checkbox",
      id: f,
      children: [
        /* @__PURE__ */ i(
          V,
          {
            "aria-labelledby": f,
            ...c,
            checked: d,
            className: m.checkboxBox,
            onCheckedChange: (b) => {
              o == null || o(b), s(b);
            },
            children: /* @__PURE__ */ i(W, { className: m.indicator, children: /* @__PURE__ */ i(j, { color: "blue", size: "xsm" }) })
          }
        ),
        a
      ]
    }
  );
};
export {
  pe as Checkbox,
  ke as CheckboxGroup
};
